import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";

import AuthenticatedLayout from "../Layouts/AuthenticatedLayout";
import LicenseCheckGate from "./LicenseCheckGate";
import ScreenLoader from "../Components/shared/ScreenLoader";
import { superAdminRoutes } from "../data";
import canView from "../utils/permissions/canView";
import getBankCorrespondingView from "../utils/permissions/getCorrespondingView";
import { logoutHandler } from "../utils/auth/logout";

const AuthenticationGate = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();
  const { licenseValidity } = useSelector((state) => state);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  //return a screen loader if keycloak adaptar is not initialized yet
  if (!initialized) return <ScreenLoader />;

  //authenticate user if not authenticated
  if (!keycloak.authenticated) {
    keycloak.login();
    return <ScreenLoader />;
  }

  //redirect to /admin if the user is super-admin and trying to access bank route
  if (
    keycloak.hasRealmRole("super-admin") &&
    !superAdminRoutes.includes(pathname)
  )
    navigate("/admin", { replace: true });

  //redirect to / if the user is not a super-admin and trying to access a super-admin route
  if (
    !keycloak.hasRealmRole("super-admin") &&
    superAdminRoutes.includes(pathname)
  )
    navigate("/", { replace: true });

  //redirect user to main path if he doesn't have the permission to view the visited route
  if (
    !keycloak.hasRealmRole("super-admin") &&
    !canView(
      getBankCorrespondingView(pathname, "bank"),
      keycloak.tokenParsed.canView || [],
      keycloak.tokenParsed.blocked || [],
      keycloak.hasRealmRole("bank-admin") ? "bank-admin" : "bank-user"
    ) &&
    licenseValidity.checked
  )
    navigate("/", { replace: true });

  //redirect user to license route if the license is loacked
  if (
    keycloak.hasRealmRole("bank-admin") &&
    canView(
      "license",
      keycloak.tokenParsed.canView || [],
      keycloak.tokenParsed.blocked || [],
      "bank-admin"
    ) &&
    licenseValidity.isLocked &&
    pathname !== "/license"
  )
    navigate("/license", { replace: true });

  //logout user to if the license is locked and the user is bank-user
  if (
    keycloak.hasRealmRole("bank-user") &&
    !canView(
      "license",
      keycloak.tokenParsed.canView || [],
      keycloak.tokenParsed.blocked || [],
      "bank-user"
    ) &&
    licenseValidity.isLocked
  )
    logoutHandler(keycloak.logout, keycloak.tokenParsed["license-key"]);

  if (licenseValidity.checked || keycloak.hasRealmRole("super-admin"))
    return <AuthenticatedLayout>{children}</AuthenticatedLayout>;
  else return <LicenseCheckGate />;
};

export default AuthenticationGate;
